const WhatsappChannelMenuTypes = {
    INTEGRATION: {
        id: "integration",
        group: "settings_group",
        path: "integration",
        label: "Integration",
        tabs: [],
        implemented: true,
    },

    CHANNEL: {
        id: "detail",
        group: "settings_group",
        path: "detail",
        label: "Detail",
        tabs: [],
        implemented: true,
    },
    VISIBILITY: {
        id: "visibility",
        group: "settings_group",
        path: "visibility",
        label: "Visibility",
        tabs: [],
        implemented: true,
    },
    WALLET: {
        id: "wallet",
        group: "settings_group",
        path: "wallet",
        label: "Wallet",
        tabs: [],
        implemented: true,
    },
    NEW_TEMPLATES: {
        id: "new_template",
        group: "template_message_group",
        path: "new-template",
        label: "Create a New Template",
        tabs: [],
        implemented: false, // if you show item in menu set to true
    },
    TEMPLATE_MESSAGE_LIST: {
        id: "templates",
        group: "template_message_group",
        path: "templates",
        label: "All Templates",
        tabs: [],
        implemented: false, // if you show item in menu set to true
    },
    CHAT_STARTER_TEMPLATE: {
        id: "chat_initiator_template",
        group: "template_message_group",
        path: "chat-initiator-template",
        label: "Chat Initiator Template",
        tabs: [],
        implemented: false, // if you show item in menu set to true
    },
    BROADCAST_REQUESTS: {
        id: "broadcast_requests",
        group: "broadcast_group",
        path: "broadcast-requests",
        label: "Broadcast Requests",
        tabs: [],
        implemented: true, // if you show item in menu set to true
    },
    CUSTOMER_GROUPS: {
        id: "customer_groups",
        group: "broadcast_group",
        path: "customer-groups",
        label: "Customer Groups",
        tabs: [],
        implemented: true, // if you show item in menu set to true
    },
    LIVE_NUMBER: {
        id: "numbers",
        group: "contacts",
        path: "numbers",
        label: "Numbers",
        tabs: [],
        implemented: false, // if you show item in menu set to true
    },
    CONTACTS: {
        id: "all_contacts",
        group: "contacts",
        path: "all-contacts",
        label: "All Contacts",
        tabs: [],
        implemented: true,
    },
};

Object.keys(WhatsappChannelMenuTypes).forEach((key) => {
    if (!WhatsappChannelMenuTypes[key].implemented) {
        delete WhatsappChannelMenuTypes[key];
    }
});

export default WhatsappChannelMenuTypes;
